import * as React from "react";

import { cn } from "../../lib/utils";

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/** Pulsing placeholder shown while content is loading. */
function Skeleton({ className, ...props }: SkeletonProps) {
	return (
		<div
			className={cn(
				"animate-pulse rounded-md bg-neutral-100 dark:bg-neutral-800",
				className,
			)}
			// A placeholder has no accessible name to query by. Ahead of `props` so a
			// caller can still name its own.
			data-testid="skeleton"
			{...props}
		/>
	);
}

export { Skeleton };
